























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ServerResult } from "../../../core/http/server_result";

export const BUYERS_LIST = "BUYERS_LIST";
export const BUYER_LINK = "BUYER_LINK";

@Component
export default class ClientBuyersList extends Vue {
  @Prop() clientId!: string;
  @Prop() clientData!: any;

  documents: any[] = [];
  loading = false;
  saving = false;

  addModalOpen = false;
  selectedBuyerId: string | null = null;
  addError = "";

  @Watch("clientId")
  onClientIdChange() {
    this.loadData();
  }

  openAddModal() {
    this.selectedBuyerId = null;
    this.addError = "";
    this.addModalOpen = true;
  }

  onAddModalClose() {
    this.selectedBuyerId = null;
    this.addError = "";
  }

  onBuyerSelect(value: string | null) {
    this.selectedBuyerId = value;
    this.addError = "";
    if (value && value === this.clientId) {
      this.addError = "Нельзя привязать дистрибьютора к самому себе";
      this.selectedBuyerId = null;
    }
  }

  addBuyer() {
    if (!this.selectedBuyerId || !this.clientId) {
      return;
    }
    if (this.selectedBuyerId === this.clientId) {
      this.addError = "Нельзя привязать дистрибьютора к самому себе";
      return;
    }

    const alreadyLinked = this.documents.some(
      (row: any) => row.id === this.selectedBuyerId
    );
    if (alreadyLinked) {
      this.addError = "Этот клиент уже в списке покупателей";
      return;
    }

    this.saving = true;
    this.addError = "";
    const buyerId = this.selectedBuyerId;

    (this as any)
      .$db([
        (this as any).$q(BUYER_LINK).update(buyerId, {
          distributor_id: this.clientId
        })
      ])
      .then((result: ServerResult) => {
        const op = result.getOperation(BUYER_LINK);
        if (op.hasError && op.hasError()) {
          this.addError = "Не удалось привязать клиента";
          return;
        }
        this.addModalOpen = false;
        this.selectedBuyerId = null;
        this.$buefy.snackbar.open("Покупатель добавлен");
        this.loadData();
      })
      .catch(() => {
        this.addError = "Не удалось привязать клиента";
      })
      .finally(() => {
        this.saving = false;
      });
  }

  loadData() {
    if (!this.clientId) {
      return;
    }
    this.loading = true;

    (this as any)
      .$db([
        (this as any)
          .$q(BUYERS_LIST)
          .raw("documents.list")
          .action({
            columns: {
              id: "c.id",
              name: "c.name"
            },
            from: "s:clients",
            from_as: "c",
            page_size: 10000,
            where: {
              $eq: ["c.distributor_id", { $: this.clientId }]
            },
            order: [{ $asc: ["c.name"] }]
          })
      ])
      .then((result: ServerResult) => {
        const opResult = result.getOperation(BUYERS_LIST).getContent();
        this.documents = opResult.documents || [];
      })
      .catch(() => {
        this.documents = [];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  openDocument(row: any) {
    this.$router.replace({
      name: "client-details",
      params: {
        id: row.id
      }
    });
  }

  mounted() {
    this.loadData();
  }
}
